import React, { createContext, useContext, useState } from 'react';

const AuthContext = createContext(null);

// Admin emails list
const ADMIN_EMAILS = [
  'umesh@datamatrixtech.com',
  'arulp@datamatrixtech.com',
  'sudeep@datamatrixtech.com',
  'santoshb@datamatrixtech.com'
];

export const AuthProvider = ({ children }) => {
  // Hydrate synchronously from localStorage so route guards don't bounce
  // authenticated users back to login on hard refresh / direct URL access.
  const [user, setUser] = useState(() => {
    try {
      const stored = localStorage.getItem('user');
      const token = localStorage.getItem('token');
      return stored && token ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  });
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return Boolean(localStorage.getItem('user') && localStorage.getItem('token'));
  });

  const login = (email, token) => {
    const userData = { email };
    setUser(userData);
    setIsAuthenticated(true);
    localStorage.setItem('user', JSON.stringify(userData));
    localStorage.setItem('token', token);
  };

  const logout = () => {
    setUser(null);
    setIsAuthenticated(false);
    localStorage.removeItem('user');
    localStorage.removeItem('token');
  };

  const isAdmin = () => {
    return user && ADMIN_EMAILS.includes(user.email.toLowerCase());
  };

  return (
    <AuthContext.Provider value={{ user, isAuthenticated, isAdmin, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
